export const defaultTheme = {
    text: '#595850',
    background: '#FFFFFF',
}

export const dark = {
    text: 'white',
    background: '#333333',
}

export const grey = {
    text: '#595850',
    background: '#E6E6E6',
}

export const warmBrown = {
    text: '#4D402E',
    background: '#EBE8E4',
}

export const coolBrown = {
    text: '#595047',
    background: '#F0EFED',
}

export const blue = {
    text: '#2E3D4D',
    background: '#E4E7EB',
}

export const cream = {
    text: '#59574C',
    background: '#FAF9F5',
}

export const none = {
    text: null,
    background: null,
}

// Map themes

export const themes = {
    'default': defaultTheme,
    'dark': dark,
    'grey': grey,
    'warm-brown': warmBrown,
    'cool-brown': coolBrown,
    'blue': blue,
    'cream': cream,
    'none': none
}

export default themes


// WEBPACK FOOTER //
// ./src/styles/themes.js